export async function getDeviceFingerprint() {
    const { userAgent, language, platform } = navigator;
    const { width, height, colorDepth } = window.screen;
    
    const rawData = `${userAgent}|${language}|${platform}|${width}x${height}|${colorDepth}`;
    
    const encoder = new TextEncoder();
    const data = encoder.encode(rawData);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const fingerprint = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");

    return fingerprint;
}
